import React from 'react';
import { Row, Col, InputGroup, Form } from 'react-bootstrap';
import { IcoPadlockOpen, IcoPadlockClosed } from '@icons';

const StepOne = ({ aggregate, onChange }) => {
	return (
		<>
			<Row className="flex-column content-step-modal">
				<Col>
					<span className="content-title">Informazioni di base</span>
				</Col>

				<Col>
					<div className="content-form">
						<Row className="mt-4">
							<Form.Group as={Col} className="col-6">
								<Form.Label>Nome del gruppo</Form.Label>
								<Form.Control
									type="text"
									name="name"
									placeholder="Inserisci il nome del gruppo..."
									value={aggregate.name ?? ''}
									onChange={(e) => onChange(e, 'name')}
									maxLength={70}
								/>
								<Form.Text className='input-description-text'>Massimo {aggregate.name.length}/70 caratteri alfanumerici</Form.Text>
							</Form.Group>
						</Row>

						<Row className="mt-4">
							<Form.Group as={Col} className="col-6">
								<Form.Label>Descrizione del gruppo</Form.Label>
								<Form.Control
									as="textarea"
									name="description"
									placeholder="Inserisci una descrizione del gruppo..."
									style={{ resize: 'none' }}
									value={aggregate.description || ''}
									onChange={(e) => onChange(e, 'description')}
									rows={10}
								/>
							</Form.Group>
						</Row>
					</div>
				</Col>
			</Row>

			<Row className="flex-column content-step-modal">
				<Col>
					<span className="content-title">Accesso</span>
				</Col>

				<Col>
					<div className="content-form">
						<Row className="mt-4">
							<Col className="col-auto">
								<InputGroup className={`aggregate-access-radio-group${aggregate.isPublic === true ? '-checked' : ''}`}>
									<InputGroup.Radio
										className="col-1"
										id="checkIsPublic"
										name="public"
										value="true"
										checked={aggregate.public === true}
										onChange={(e) => onChange(true, 'public')}
									/>
									<InputGroup.Text className="col-10 flex-column align-items-start text-start p-2" style={{ whiteSpace: 'normal' }}>
										<Row className="d-flex align-items-center">
											<Col className="pe-0 f-500">
												<span style={{ fontSize: '18px', lineHeight: '28px' }}>Pubblico</span>
											</Col>
											<Col className="p-0 d-flex align-items-center">
												<IcoPadlockOpen className="ico-path-fill-primary ms-2" width={16} />
											</Col>
										</Row>
										<Row>
											<span className="f-400 mt-1" style={{ fontSize: '14px' }}>
												Crea un gruppo di progetti accessibile e modificabile da te e i tuoi colleghi.
											</span>
										</Row>
									</InputGroup.Text>
								</InputGroup>
							</Col>
							<Col className="col-auto">
								<InputGroup className={`aggregate-access-radio-group${aggregate.isPublic === false ? '-checked' : ''}`}>
									<InputGroup.Radio
										className="col-1"
										id="checkIsPrivate"
										name="public"
										value="false"
										checked={aggregate.public === false}
										onChange={(e) => onChange(false, 'public')}
									/>
									<InputGroup.Text className="col-10 flex-column align-items-start text-start p-2" style={{ whiteSpace: 'normal' }}>
										<Row className="d-flex align-items-center">
											<Col className="pe-0 f-500">
												<span style={{ fontSize: '18px', lineHeight: '28px' }}>Privato</span>
											</Col>
											<Col className="p-0 d-flex align-items-center">
												<IcoPadlockClosed className="ico-path-fill-primary ms-2" width={16} />
											</Col>
										</Row>
										<Row>
											<span className="f-400 mt-1" style={{ fontSize: '14px' }}>
												Crea un gruppo di progetti accessibile e modificabile esclusivamente da te.
											</span>
										</Row>
									</InputGroup.Text>
								</InputGroup>
							</Col>
						</Row>
					</div>
				</Col>
			</Row>
		</>
	);
};
export default StepOne;
